import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "../lib/images";

const CHAPTERS = [
  {
    n: "01",
    title: "Conciencia y comprensión",
    text: [
      "Comprende cómo se forman tus pensamientos, creencias, emociones y patrones de comportamiento.",
      "Aprende a observar tu historia con mayor claridad para reconocer aquello que hoy influye en tu manera de vivir.",
    ],
  },
  {
    n: "02",
    title: "Regulación emocional y sistema nervioso",
    text: [
      "Aprende a reconocer lo que sientes, comprender las respuestas de tu cuerpo y desarrollar herramientas para recuperar seguridad interna.",
      "La regulación permite que el cambio no ocurra solo en la mente, sino también en la experiencia cotidiana.",
    ],
  },
  {
    n: "03",
    title: "Transformación e integración",
    text: [
      "Convierte la comprensión en decisiones, hábitos y nuevas formas de relacionarte contigo, con los demás y con tu vida.",
      "Integrar significa llevar lo aprendido más allá de la teoría y convertirlo en una manera diferente de vivir.",
    ],
  },
];

export const Manifesto = () => (
  <section id="filosofia" className="relative overflow-hidden bg-cream py-24 text-navy sm:py-32" data-testid="about-section">
    <div className="container-luxe">
      <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <Reveal>
            <p className="overline mb-6 flex items-center gap-4 text-gold-deep">
              <span className="h-px w-10 bg-gold-deep" /> Nuestro enfoque
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              Tres dimensiones. <span className="italic text-gold-deep">Un mismo proceso.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-md text-base font-light leading-relaxed text-navy/70 sm:text-lg">
              La transformación profunda requiere comprender lo que ocurre en tu mente, aprender a
              regular lo que sucede en tu cuerpo y convertir esa comprensión en una nueva forma de
              vivir. Estas tres dimensiones trabajan juntas dentro del recorrido de la Academia.
            </p>
          </Reveal>

          <Reveal delay={0.3}>
            <div className="mt-12 overflow-hidden rounded-sm border border-gold/30">
              <img
                src={IMAGES.aboutTexture}
                alt="Ondas doradas sobre agua profunda"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-6 md:col-start-7 md:pt-16">
          <div className="flex flex-col gap-5">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.12}>
                <motion.div
                  whileHover={{ y: -4 }}
                  transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                  className="rounded-sm border border-navy/10 bg-white/60 p-7 transition-colors duration-300 hover:border-gold-deep/40"
                  data-testid={`pillar-card-${c.n}`}
                >
                  <div className="flex items-center gap-4">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold-deep/40 font-serif text-lg text-gold-deep">
                      {c.n}
                    </span>
                    <h3 className="font-serif text-2xl font-normal leading-tight">{c.title}</h3>
                  </div>
                  <div className="mt-4 flex flex-col gap-3">
                    {c.text.map((para, j) => (
                      <p key={para} className="text-base font-light leading-relaxed text-navy/70">
                        {para}
                      </p>
                    ))}
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
